module.exports = __webpack_public_path__ + "img/composite.4d6ae0fa.jpg";